import { render, staticRenderFns } from "./ActualLinked.vue?vue&type=template&id=a1df48b8&"
import script from "./ActualLinked.vue?vue&type=script&lang=js&"
export * from "./ActualLinked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports